import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AnonymousAuthGuard: CanActivateFn = async (route, state) => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  try {
    const user = await _authService.getCurrentUser();

    // ✅ Authenticated user
    if (user) return true;

    // 🟡 Not authenticated user
    const currentUrl = state.url;

    if (currentUrl.startsWith('/home/properties')) {
      // 🛡️ Create anonymous session
      await _authService.startAnonymousSession();
      return true;
    }

    // 🚫 Redirect to login for any other route
    return _router.parseUrl('/login');
  } catch (error) {
    return _router.parseUrl('/login');
  }
};
